import React from "react";
import useStyles from "../partner/style";
import { TextField } from "@material-ui/core";

const InputLogin = ({ text, setValue, type, label, name, placeholder, isEnable, isRequired }) => {
    const classes = useStyles();
    const onChange = (e) => {
        setValue({ ...text, text: e.target.value });
    }

    return (
        <div>
            <div className={classes.divLabel}>
                <p className={classes.label} >{label}</p>
                {isRequired ? (
                    <p style={{ fontSize: 26, color: "#FF0000" }}>*</p>
                ) : (
                    <></>
                )}
            </div>

            <TextField
                InputProps={{
                    classes: {
                        focused: classes.textBorder,
                        input: classes.input,
                    },
                }}
                disabled={isEnable ?? false}
                value={text.text}
                onChange={onChange}
                placeholder={placeholder}
                type={type}
                name={name}
                style={{ width: '85%' }}
                inputStyle={{ width: '85%' }}
            />
        </div>
    );
}

export default InputLogin;